import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { VerificationStatus } from '@/types/provider-destinations';

import { VERIFICATION_BADGE_COLORS } from './utils';

interface VerificationBadgeProps {
  status: VerificationStatus;
  className?: string;
}

const STATUS_LABELS: Record<VerificationStatus, string> = {
  VERIFIED: 'Verified',
  PENDING: 'Pending',
  UNVERIFIED: 'Unverified',
  DISPUTED: 'Disputed',
  ARCHIVED: 'Archived',
};

export const VerificationBadge = ({
  status,
  className,
}: VerificationBadgeProps) => {
  return (
    <Badge
      variant="outline"
      className={cn(
        'border-none text-[11px] font-medium',
        VERIFICATION_BADGE_COLORS[status],
        className,
      )}
    >
      {STATUS_LABELS[status]}
    </Badge>
  );
};
